import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { VariantPickerProps } from './types/VariantPicker.Inteface';
import styled from 'styled-components';
import { DropdownOption } from '../Dropdown';
import { translate } from '../../Services/translation';
import { groupBy, sumBy } from 'lodash';
import NewDropdown from './NewDropdown';

const FIRST_VARIANT_VALUE = 'firstVariantValue';
const SECOND_VARIANT_VALUE = 'secondVariantValue';

interface StyledVariantWrapperProps {
  $dropDownSize: 'small' | 'large' | undefined;
}

const StyledVariantWrapper = styled.div<StyledVariantWrapperProps>`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: ${(p) => (p.$dropDownSize == 'small' ? '0.8rem' : '1.6rem')};
`;

const VariantMultiPickerDropdown = (props: VariantPickerProps) => {

  const GetUniqueRows = (): DropdownOption[] => {
    var uniqueRowOptions = groupBy(props.options, x => x.firstVariantValue)

    const result: any = Object.keys(uniqueRowOptions).map(key => {
      const first = uniqueRowOptions[key][0];
      return {
        ...first,
        "stockStatus": sumBy(uniqueRowOptions[key], i => i.stockStatus),
      };
    });

    return result.map(x => {
      return {
        value: x.variantId,
        label: x.firstVariantValue,
        inStock: x.inStock,
        stockStatus: x.stockStatus,
        articleNumber: x.articleNumber,
        isDisabled: false,
      };
    })
  };

  const GetUniqueColumns = (rowValue?: string): DropdownOption[] => {
    var uniqueColumnOptions = groupBy(props.options, x => x.secondVariantValue)
    var uniqueColumnOptionsWithMatchingRow = props.options.filter(x => x.firstVariantValue == rowValue).map(x => x.secondVariantValue)
    
    const result: any = Object.keys(uniqueColumnOptions).map(key => {
      const first = uniqueColumnOptions[key]?.at(0);
      
      if (rowValue) {
        return {
          ...first,
          "stockStatus":  sumBy(uniqueColumnOptions[key]?.filter(x => x.firstVariantValue == rowValue), i => i.stockStatus),
        };
      } else {
        return {
          ...first,
          "stockStatus": sumBy(uniqueColumnOptions[key], i => i.stockStatus),
        };
      }
    });

    return result.map(x => {
      return {
        value: x.variantId,
        label: x.secondVariantValue,
        inStock: x.inStock,
        stockStatus: x.stockStatus,
        articleNumber: x.articleNumber,
        isDisabled: !uniqueColumnOptionsWithMatchingRow.includes(x.secondVariantValue),
      };
    })
  };

  const [rowOptions, setRowOptions] = useState<Array<DropdownOption>>(GetUniqueRows());
  const [columnOptions, setColumnOptions] = useState<Array<DropdownOption>>(GetUniqueColumns());
  const [selectedRow, setSelectedRow] = useState<string | null>(props.options.find(x => x.variantId == props.selectedVariantId)?.firstVariantValue ?? null);
  const [selectedColumn, setSelectedColumn] = useState<string | null>(props.options.find(x => x.variantId == props.selectedVariantId)?.secondVariantValue ?? null);

  useEffect(() => {
    updateRowOptions();
    updateColumnOptions();

    if (selectedRow != '' && selectedColumn != '') {
      selectVariant();
    }
  }, [selectedRow, selectedColumn]);

  const selectVariant = () => {
    let _selectedVariant = props.options.find(
      (x) =>
        x.firstVariantValue == selectedRow &&
        x.secondVariantValue == selectedColumn
    );
    
    if (_selectedVariant) {
      props.setSelectedArticleNumber(_selectedVariant);
    } else {
      setSelectedColumn('');
      props.setSelectedArticleNumber('');
    }
  };

  const updateRowOptions = () => {
    if (selectedColumn != '') {
      var uniqueRowOptions = [
        ...new Map(
          props.options
            .filter((x) => x.secondVariantValue == selectedColumn)
            .map((item) => [item[FIRST_VARIANT_VALUE], item])
        ).values(),
      ];
      var rowOptions = uniqueRowOptions.map((x) => {
        return {
          value: x.variantId,
          label: x.firstVariantValue,
          disabled: false,
        };
      });
      setRowOptions(GetUniqueRows());
    } else {
      setRowOptions(GetUniqueRows());
    }
  };

  const updateColumnOptions = () => {
    if (selectedRow != '') {
      setColumnOptions(GetUniqueColumns(selectedRow));
    } else {
      setColumnOptions(GetUniqueColumns());
    }
  };

  const onVariantRowChange = (event) => {
    setSelectedRow(event.label);
  };

  const onVariantColumnChange = (event) => {
    setSelectedColumn(event.label);
  };

  const handleButtonClick = () => {
    props.setIsModalOpen();
  };

  return (
    <>
      <NewDropdown
        selectorField='label'
        options={GetUniqueRows()}
        onChange={onVariantRowChange}
        selectedValue={selectedRow}
        placeholder={translate('select.placeholder') + ' ' + props.firstVariant}
        isBackOrder={props.isBackOrder}
        onButtonClick={handleButtonClick}
      />

      <NewDropdown
        selectorField='label'
        options={columnOptions}
        onChange={onVariantColumnChange}
        selectedValue={selectedColumn}
        placeholder={translate('select.placeholder') + ' ' + props.secondVariant}
        isBackOrder={props.isBackOrder}
        onButtonClick={handleButtonClick}
      />
    </>
  );
};

export default VariantMultiPickerDropdown;
